import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["iconComponent", "artworkSrc", "title", "href", "enableIcon"],
    _excluded2 = ["theme", "children"],
    _excluded3 = ["children", "searchPlaceHolder", "searchValue", "onSearchChange", "inputProps"];
import React, { useState } from 'react';
import { useThemeDefaults } from "../utils";
import styled, { withTheme } from "styled-components";
import { boxShadow, alignItems } from "styled-system";
import MenuList from '../MenuList';
import Box from "../Box";
import Img from "../Img";
import Text from '../Text';
import BaseHR from '../HR';
import { Text as BaseTextInput } from '../Input';
import SearchAltIcon from '../Icons/SearchAltIcon';
export var Item = useThemeDefaults(function (_ref) {
  var theme = _ref.theme;
  return {
    display: theme.artworkMenuList.item.display,
    width: theme.artworkMenuList.item.width,
    paddingTop: theme.artworkMenuList.item.paddingTop,
    paddingBottom: theme.artworkMenuList.item.paddingBottom,
    alignItems: theme.artworkMenuList.item.alignItems
  };
}, styled(function (_ref2) {
  var iconComponent = _ref2.iconComponent,
      artworkSrc = _ref2.artworkSrc,
      title = _ref2.title,
      href = _ref2.href,
      enableIcon = _ref2.enableIcon,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(MenuList.Item, _extends({
    as: "a",
    href: href
  }, props), enableIcon && /*#__PURE__*/React.createElement(Icon, null, iconComponent), /*#__PURE__*/React.createElement(Artwork, {
    src: artworkSrc
  }), /*#__PURE__*/React.createElement(Title, null, title));
}).withConfig({
  displayName: "ArtworkMenuList__Item",
  componentId: "sc-eke7x8-0"
})(alignItems));

var _ref3 = /*#__PURE__*/React.createElement(BaseHR, {
  sa: "spacer10",
  sb: "spacer10"
});

export var HR = function HR() {
  return _ref3;
};
var Icon = useThemeDefaults(function (_ref4) {
  var theme = _ref4.theme;
  return {
    width: theme.artworkMenuList.icon.width,
    height: theme.artworkMenuList.icon.height,
    minWidth: theme.artworkMenuList.icon.minWidth,
    marginRight: theme.artworkMenuList.icon.marginRight
  };
}, Box);
var Artwork = useThemeDefaults(function (_ref5) {
  var theme = _ref5.theme;
  return {
    height: theme.artworkMenuList.artwork.height,
    width: theme.artworkMenuList.artwork.width,
    marginRight: theme.artworkMenuList.artwork.marginRight,
    objectFit: theme.artworkMenuList.artwork.objectFit,
    borderRadius: theme.artworkMenuList.artwork.borderRadius,
    boxShadow: theme.artworkMenuList.artwork.boxShadow
  };
}, styled(Img).withConfig({
  displayName: "ArtworkMenuList__Artwork",
  componentId: "sc-eke7x8-1"
})(boxShadow));
var Title = useThemeDefaults(function (_ref6) {
  var theme = _ref6.theme;
  return {
    textStyle: theme.artworkMenuList.title.textStyle,
    color: theme.artworkMenuList.title.color,
    whiteSpace: theme.artworkMenuList.title.whiteSpace
  };
}, Text);

var SearchInput = function SearchInput(_ref7) {
  var props = _extends({}, _ref7);

  return /*#__PURE__*/React.createElement(SearchWrapper, null, /*#__PURE__*/React.createElement(TextInput, _extends({
    type: "text",
    IconComponent: SearchAltIcon,
    clearable: true
  }, props)));
};

var SearchWrapper = styled(Box).withConfig({
  displayName: "ArtworkMenuList__SearchWrapper",
  componentId: "sc-eke7x8-2"
})(["padding-top:15px;& svg{left:20px;}& button{right:10px;}"]);
var TextInput = styled(BaseTextInput).withConfig({
  displayName: "ArtworkMenuList__TextInput",
  componentId: "sc-eke7x8-3"
})(["padding-left:44px;border:none;&:focus{border:none;box-shadow:none;}"]);
var HOCMenuList = withTheme( /*#__PURE__*/React.forwardRef(function (props, ref) {
  var theme = props.theme,
      children = props.children,
      rest = _objectWithoutProperties(props, _excluded2);

  return /*#__PURE__*/React.createElement(MenuList, _extends({
    maxHeight: theme.artworkMenuList.menuList.maxHeight,
    minWidth: theme.artworkMenuList.menuList.minWidth
  }, rest), children);
}));

var _ref8 = /*#__PURE__*/React.createElement(BaseHR, {
  sa: "spacer10",
  sb: "spacer0"
});

export var ArtworkMenuList = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      searchPlaceHolder = props.searchPlaceHolder,
      searchValue = props.searchValue,
      onSearchChange = props.onSearchChange,
      inputProps = props.inputProps,
      rest = _objectWithoutProperties(props, _excluded3);

  var hasIcon = children.map(function (child) {
    return child.type.displayName && child.type.displayName.includes("ArtworkMenuList__Item") && child.props.iconComponent != null;
  }).reduce(function (acc, item) {
    return acc || item;
  }, false);

  var _useState = useState(hasIcon),
      _useState2 = _slicedToArray(_useState, 2),
      enableIcon = _useState2[0],
      setEnableIcon = _useState2[1];

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchInput, _extends({
    placeholder: searchPlaceHolder,
    value: searchValue,
    onChange: onSearchChange
  }, inputProps)), _ref8, /*#__PURE__*/React.createElement(HOCMenuList, _extends({
    ref: ref
  }, rest), React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      enableIcon: enableIcon
    });
  })));
});
ArtworkMenuList.Item = Item;
ArtworkMenuList.HR = HR;
export default ArtworkMenuList;